import { render } from "./PediatricVisitModal.vue?vue&type=template&id=151fa048&scoped=true"
import script from "./PediatricVisitModal.vue?vue&type=script&lang=js"
export * from "./PediatricVisitModal.vue?vue&type=script&lang=js"

import "./PediatricVisitModal.vue?vue&type=style&index=0&id=151fa048&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151fa048"]])

export default __exports__